module.exports = __webpack_public_path__ + "img/T920.fff9551c.jpg";